import { render, staticRenderFns } from "./addPlan.vue?vue&type=template&id=232631dd&scoped=true&"
import script from "./addPlan.vue?vue&type=script&lang=tsx&"
export * from "./addPlan.vue?vue&type=script&lang=tsx&"
import style0 from "./addPlan.vue?vue&type=style&index=0&id=232631dd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "232631dd",
  null
  
)

export default component.exports